import _asyncToGenerator from "/www/wwwroot/shishai_admin_fe/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import request from "../../utils/request";
export default {
  name: 'EditDownTable',
  props: {
    requestUrl: '',
    columnData: Array,
    parent: Object,
    // 暂未使用
    params: Object
  },
  data: function data() {
    return {
      row: null,
      column: null,
      loading: false,
      tableData: [],
      tableColumn: [],
      fetchTableData: [],
      tablePage: {
        total: 0,
        currentPage: 1,
        pageSize: 5,
        pageSizes: [5, 10, 20, 50, 100]
      }
    };
  },
  created: function created() {
    this.load();
  },
  mounted: function mounted() {
    this.keyupEvent = _.debounce(this.keyupEvent, 300);
  },
  methods: {
    load: function load() {
      if (this.columnData.length > 0) this.tableColumn = this.columnData;
      var _this$params = this.params,
          row = _this$params.row,
          column = _this$params.column;
      this.row = row;
      this.column = column; // this.fetchData().then(data => {
      //   this.tableData = data
      // })
    },
    fetchData: function fetchData() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return request({
                  url: _this.requestUrl,
                  method: "post",
                  params: {
                    keyword: _this.row[_this.column.property],
                    pageSize: _this.tablePage.pageSize,
                    page: _this.tablePage.currentPage
                  }
                }).then(function (res) {
                  if (res.code == 200) {
                    _this.fetchTableData = res.data.list;
                    _this.tablePage.total = res.data.count;
                  }
                }).catch(function (err) {});

              case 2:
                return _context.abrupt("return", new Promise(function (resolve) {
                  setTimeout(function () {
                    resolve(_this.fetchTableData);
                  }, 0);
                }));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    clickEvent: function clickEvent() {
      var _this2 = this;

      if (this.tableData.length < 1) {
        this.fetchData().then(function (data) {
          _this2.tableData = data;
        });
      }

      this.$refs.xDown.showPanel();
    },
    keyupEvent: function keyupEvent(params) {
      var _this3 = this;

      // console.log('输入框键盘事件：', params)      
      // 键盘切换焦点 选中表格数据第一行
      var $event = params.$event,
          value = params.value;
      var row = this.row,
          column = this.column;
      var cellValue = row[column.property];

      if ($event.keyCode == 40 || $event.keyCode == 13 || $event.keyCode == 38) {
        // ArrowDown 下箭头 ， Enter 回车 ， ArrowUp 上箭头
        this.$refs.vxeInput.blur();
        setTimeout(function () {
          _this3.$refs.vxeGrid.focus();

          if (!_this3.$refs.vxeGrid.getCurrentRecord()) _this3.$refs.vxeGrid.setCurrentRow(_this3.tableData[0]);
        }, 0);
        return;
      }

      this.loading = true;
      this.fetchData().then(function (data) {
        _this3.loading = false;

        _this3.$refs.xDown.showPanel(); // if (cellValue) {
        //   this.tableData = data.filter(item => item.name.indexOf(cellValue) > -1)
        // } else {


        _this3.tableData = data; // }
      });
    },
    suffixClick: function suffixClick() {
      this.$refs.xDown.togglePanel();
    },
    pageChangeEvent: function pageChangeEvent(_ref) {
      var _this4 = this;

      var currentPage = _ref.currentPage,
          pageSize = _ref.pageSize;
      this.tablePage.currentPage = currentPage;
      this.tablePage.pageSize = pageSize;
      this.loading = true;
      this.fetchData().then(function (data) {
        _this4.loading = false;
        _this4.tableData = data;
      });
    },
    keydownEvent: function keydownEvent(params) {
      // console.log('keydownEvent: ', params)
      var $event = params.$event,
          $grid = params.$grid;

      if ($event.keyCode == 27) {
        // Escape 取消
        this.$refs.xDown.hidePanel();
      }

      if ($event.keyCode == 13) {
        var row = this.row,
            column = this.column;
        var currRow = $grid.getCurrentRecord();
        row[column.property] = currRow[column.property];
        this.$refs.xDown.hidePanel();
      }
    },
    doubleEvent: function doubleEvent(params) {
      var row = this.row,
          column = this.column;
      row[column.property] = params.row[column.property]; // 更新原始row数据

      this.tableColumn.forEach(function (item) {
        if (item.type != 'seq' && item.field) {
          row[item.field] = params.row[item.field];
        }
      });
      this.$refs.xDown.hidePanel(); // 触发父表格更新

      this.params.$table.updateStatus({
        row: row,
        column: column
      });
    },
    selectEvent: function selectEvent(params) {// console.log('单击: ', params)
      // const { row, column } = this
      // row[column.property] = params.row.name
      // this.$refs.xDown.hidePanel()
    }
  }
};